import { createGlobalStyle } from 'styled-components';
import { Theme } from '../interfaces/styled';

export interface GlobalStylesProps {
  theme: Theme;
}

const GlobalStyles = createGlobalStyle<GlobalStylesProps>`
  html {
    height: 100%;
    scroll-behavior: smooth;
  }
  
  body {
    height: 100%;
    font-family: ${({ theme }) => theme.family};
    font-size: ${({ theme }) => theme.fontSize.md}px;
    font-weight: 500;
    line-height: 1;
    background: ${({ theme }) => theme.colors.bg};
    margin: 0;
  }
  
  #root {
    height: 100%;
  }
`;

export { GlobalStyles };
